import "@/assets/styles.css";

import { createRoot } from "react-dom/client";

import App from "./app/App";

// index.html removes the root in a browser the app does not support and shows an update notice
const container = document.getElementById("root");
if (container) {
  createRoot(container).render(<App />);
}
